import { useEffect } from 'react';
import $checkout from '@flittpayments/js-sdk';

export const useFlittWallets = ({ methods = ['apple', 'google'], amount, merchantId, handleToken, onSuccess, onError, element, params } = {}) => {
  useEffect(() => {
    const initializeFlittWallets = () => {
      const wallets = $checkout.get('PaymentButton', {
        methods,
        element: element,
        css: {},
        style: {
          mode: 'pay',
          color: 'black',
          height: 48,
        },
        data: {
          merchant_id: merchantId,
          currency: 'GEL',
          amount: parseFloat(amount) * 100,
          token: params?.token,
        },
        // before(response) {
        //   handleToken()
        //     .then((token) => {
        //       return wallets.update({
        //         token: token,
        //       });
        //     })
        //     .then(() => response.resolve());
        // },
        ...params,
      });

      wallets.on('success', onSuccess);
      wallets.on('error', onError);

      return () => {
        wallets.off('success', onSuccess);
        wallets.off('error', onError);
        wallets.destroy();
      };
    };

    const unsubscribe = initializeFlittWallets();
    return unsubscribe;
  }, []);
};
